import React, { useState, useEffect } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { TextField } from '@mui/material';
import Button from '@mui/material/Button';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { client, actionGetExchangeRate } from "../store/action/RemoteActionSupervisor";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";

let BASE_URL = process.env.REACT_APP_SERVER_URL_API;

const ExchangeRate = (props) => {
    const [language, setLanguage] = useState("");
    const [oldEuroAgathaRate, setOldEuroAgathaRate] = useState(0);
    const [euroAgathaRate, setEuroAgathaRate] = useState(0);
    const [oldBitcoinAgathaRate, setOldBitcoinAgathaRate] = useState(0);
    const [bitcoinAgathaRate, setBitcoinAgathaRate] = useState(0);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);

    const handleEuroAgathaChange = (e) => {
        let inputVal = e.target.value.replace(/[^0-9.]/g, "");
        setEuroAgathaRate(inputVal);
    };

    const handleBitcoinAgathaChange = (e) => {
        let inputVal = e.target.value.replace(/[^0-9.]/g, "");
        setBitcoinAgathaRate(inputVal);
    };

    const updateCurrencyRate = async () => {
        if (parseFloat(oldEuroAgathaRate) === parseFloat(euroAgathaRate) && parseFloat(oldBitcoinAgathaRate) === parseFloat(bitcoinAgathaRate)) {
            alert(getMultiLanguageMessage('msg_NoChangesMade_Error', language));
            return;
        }

        if (!euroAgathaRate || !euroAgathaRate.match(/^\d{1,}(\.\d{0,2})?$/) || parseFloat(euroAgathaRate) <= 0) {
            alert(getMultiLanguageMessage('msg_InvalidAmount_Error', language));
            return;
        }
        if (!bitcoinAgathaRate || !bitcoinAgathaRate.match(/^\d{1,}(\.\d{0,8})?$/) || parseFloat(bitcoinAgathaRate) <= 0) {
            alert(getMultiLanguageMessage('msg_InvalidAmount_Error', language));
            return;
        }

        if (window.confirm(getMultiLanguageMessage('msg_Update_Confirm', language))) {
            setIsButtonClicked(true);
            let adminId = localStorage.getItem("supervisorid");
            let index = 0;
            let rate = 0;
            let isError = false;
            for (index = 0; index < props?.exchangeRateList?.length; index++) {
                let exchangeRate = props.exchangeRateList[index];
                if (exchangeRate.FromCurrency === 'EURO') {
                    rate = euroAgathaRate;
                } else if (exchangeRate.FromCurrency === 'BTC') {
                    rate = bitcoinAgathaRate;
                }
                const params = {
                    VfaspID: process.env.REACT_APP_VFASP_CODE,
                    AdminID: adminId,
                    Rate: rate,
                    FromCurrency: exchangeRate.FromCurrency
                };

                await client(localStorage.getItem("supervisortoken")).put(`${BASE_URL}/exchangerate/update`, params).then((response) => {
                    setIsSubmitSuccess(true);
                }).catch(error => {
                    alert(getMultiLanguageMessage('msg_Server_Error', language));
                    setIsSubmitSuccess(false);
                    isError = true;
                });
                if (isError) {
                    break;
                }
            }
            setIsButtonClicked(false);
        }
    };

    useEffect(() => {
        if (props?.exchangeRateList?.length > 0) {
            let index = 0;
            for (index = 0; index < props?.exchangeRateList?.length; index++) {
                let exchangeRate = props.exchangeRateList[index];
                if (exchangeRate.FromCurrency === 'EURO') {
                    setOldEuroAgathaRate(exchangeRate.Rate.toString());
                    setEuroAgathaRate(exchangeRate.Rate.toString());
                } else if (exchangeRate.FromCurrency === 'BTC') {
                    setOldBitcoinAgathaRate(exchangeRate.Rate.toString());
                    setBitcoinAgathaRate(exchangeRate.Rate.toString());
                }
            }
        }
    }, [props.exchangeRateList]);

    useEffect(() => {
        if (props?.supervisor?.length > 0) {
            props.actionGetExchangeRate();
        }
    }, [props.supervisor]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        props.actionToggleNavBar(true);
        props.actionToggleSideBar(true);
        props.actionToggleFooter(true);
    }, []);

    return ((props?.supervisor?.length > 0) ?
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-ExchangeRate')}</h2>

            {/* .nav-tabs-line */}
            <div className="tab-content" id="security-opt-tab">
                {/* .tab-pane */}
                <div className="tab-pane active show" id="password-opt">
                    <form action="#">
                        {/* .row */}

                        <table width='100%'>
                            <tbody>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Euro-Agatha')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField
                                            size="small"
                                            id="id_EURO-AGATHA"
                                            sx={{ width: '24.5ch' }}
                                            value={euroAgathaRate}
                                            defaultValue={euroAgathaRate}
                                            onChange={handleEuroAgathaChange}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">{translate('Euro')}</InputAdornment>,
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Bitcoin-Agatha')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField
                                            size="small"
                                            id="id_EURO-AGATHA"
                                            sx={{ width: '24.5ch' }}
                                            value={bitcoinAgathaRate}
                                            defaultValue={bitcoinAgathaRate}
                                            onChange={handleBitcoinAgathaChange}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">{translate('Bitcoin')}</InputAdornment>,
                                            }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {isButtonClicked &&
                            <>
                                <div className="gaps" />
                                <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                            </>
                        }
                        <div className="gaps-2x" />
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <div className="gaps-2x d-sm-none" />
                            <span className="color-success">
                                {isSubmitSuccess &&
                                    <div>
                                        <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                        <div className="gaps-1x" />
                                    </div>
                                }
                            </span>
                        </div>

                        {/* 10px gap */}
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => updateCurrencyRate()}>{translate('btnUpdate')}</Button>
                            <div className="gaps-2x d-sm-none" />
                        </div>
                    </form>
                    {/* form */}
                </div>
                {/* .tab-pane */}
            </div>
            {/* .tab-content */}
        </div>
        : "");
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        supervisor: state.remote.supervisor,
        exchangeRateList: state.remote.exchangeRateList
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter,
    actionGetExchangeRate
})(ExchangeRate);
